module.exports = __webpack_public_path__ + "static/media/simona.cb57c19b.jpg";